import React, { useState } from 'react';
import { IconContext } from 'react-icons';
import { MdOutgoingMail } from 'react-icons/md';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import './Footer.scss';

const Footer = () => {
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		message: '',
	});
	const [isFormSubmitted, setIsFormSubmitted] = useState(false);
	const [loading, setLoading] = useState(false);

	const { username, email, message } = formData;

	const handleChangeInput = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleSubmit = () => {
		setLoading(true);

		const contact = {
			_type: 'contact',
			name: formData.username,
			email: formData.email,
			message: formData.message,
		};

		client
			.create(contact)
			.then(() => {
				setLoading(false);
				setIsFormSubmitted(true);
			})
			.catch((err) => console.log(err));
	};

	return (
		<>
			<h2 className="head-text">Trabajemos juntos</h2>

			<div className="app__footer-cards">
				<div className="app__footer-card ">
					<IconContext.Provider
						value={{ color: 'var(--secondary-color)', className: 'app_icon app_icon--mail' }}
					>
						<div>
							<MdOutgoingMail />
						</div>
					</IconContext.Provider>
					<a href="mailto:fpovinamigliavacca@gmail.com" className="p-text">
						fpovinamigliavacca@gmail.com
					</a>
				</div>
				{/* <div className="app__footer-card">
				<IconContext.Provider
						value={{ color: 'var(--secondary-color)', className: 'app_icon app_icon--phone' }}
					>
						<div>
							<BsFillTelephoneForwardFill />
						</div>
					</IconContext.Provider>					<a href="tel:+54 (381) 393-1501" className="p-text">
						+54 (381) 393-1501
					</a>
				</div> */}
			</div>
			{!isFormSubmitted ? (
				<div className="app__footer-form app__flex">
					<div className="app__flex">
						<input
							className="p-text"
							type="text"
							placeholder="Tu Nombre"
							name="username"
							value={username}
							onChange={handleChangeInput}
						/>
					</div>
					<div className="app__flex">
						<input
							className="p-text"
							type="email"
							placeholder="Tu Mail"
							name="email"
							value={email}
							onChange={handleChangeInput}
						/>
					</div>
					<div>
						<textarea
							className="p-text"
							placeholder="Tu Mensaje"
							value={message}
							name="message"
							onChange={handleChangeInput}
						/>
					</div>
					<button type="button" className="p-text" onClick={handleSubmit}>
						{!loading ? 'Mandar mensaje' : 'Mandando...'}
					</button>
				</div>
			) : (
				<div>
					<h3 className="head-text">Gracias por ponerte en contaco!</h3>
				</div>
			)}
		</>
	);
};

export default AppWrap(
	MotionWrap(Footer, 'app__footer'),
	'contactarse',
	'app__whitebg'
);
